import { ROUTES } from "@/types/routes";
import { Grid } from "antd";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router";

interface Props {
  to: ROUTES;
}

export const ConditionalRedirect: FC<Props> = ({ to }) => {
  const navigate = useNavigate();
  const { lg } = Grid.useBreakpoint();

  useEffect(() => {
    if (lg) {
      navigate(to);
    }
  }, [lg, navigate, to]);

  return null;
};